import { createFileRoute } from '@tanstack/react-router';
import { RegisterRouteComponent } from './-RegisterRouteComponent';

export const Route = createFileRoute('/register')({
  component: RegisterRouteComponent,
});
